import { toggleClass, toggleLinkRowClasses } from './utils.js'

let $map = document.querySelector('.js-terminal-map')
let $floors
let activeIndex = 0
let $up
let $down
let $toggles

if ($map) {
  $floors = $map.children
  $up = document.querySelector('[data-terminal-map="first"]')
  $down = document.querySelector('[data-terminal-map="ground"]')
  $toggles = Array.from(
    document.querySelectorAll('[data-terminal-map="toggle"]')
  )

  $up.addEventListener('click', up)
  $down.addEventListener('click', down)

  let $groundBeforePins = document.querySelector(
    '.js-terminal-map-ground-before-pins'
  )
  let $groundAfterPins = document.querySelector(
    '.js-terminal-map-ground-after-pins'
  )

  $toggles.forEach($toggle => {
    $toggle.addEventListener('click', () => {
      if ($toggle.classList.contains('bg-yellow')) return

      document
        .querySelector('.js-terminal-map-ground-before-labels')
        .classList.toggle('opacity-0')
      $groundBeforePins.classList.toggle('opacity-0')
      $groundBeforePins.classList.toggle('pointer-events-none')
      $groundAfterPins.classList.toggle('opacity-0')
      $groundAfterPins.classList.toggle('pointer-events-none')
      document
        .querySelector('.js-terminal-map-ground-before')
        .classList.toggle('opacity-20')
      document
        .querySelector('.js-terminal-map-ground-after')
        .classList.toggle('opacity-0')
      $toggles.forEach($t =>
        toggleClass($t, [
          'bg-yellow',
          'bg-transparent',
          'border-yellow',
          'border-grey-light',
          'text-current',
          'text-grey'
        ])
      )
    })
  })
}

function up () {
  setFloor(1)
  $up.disabled = true
  $down.disabled = false
  $toggles.forEach($toggle => ($toggle.disabled = true))

  toggleLinkRowClasses([$up, $down], $up)
}

function down () {
  setFloor(0)
  $up.disabled = false
  $down.disabled = true
  $toggles.forEach($toggle => ($toggle.disabled = false))

  toggleLinkRowClasses([$up, $down], $down)
}

function setFloor (index) {
  $floors[activeIndex].classList.remove('opacity-100')
  $floors[activeIndex].classList.add('opacity-0')
  $floors[activeIndex].classList.add('pointer-events-none')
  activeIndex = index
  $floors[activeIndex].classList.add('opacity-100')
  $floors[activeIndex].classList.remove('opacity-0')
  $floors[activeIndex].classList.remove('pointer-events-none')
}



// WEBPACK FOOTER //
// ./src/js/_terminal-map.js